import Container from '../common/container';
import { Translate } from '~/i18n';
/******************************************************************
 *
 *  THIS COMPONENT WAS GENERATED BY NEXTCRAZY-CLI
 *
 ******************************************************************/

const BoldSaudi = () => {
   const boldSaudiIcons = [
      { icon: '/images/about-page/experiences.png', text: <Translate id="about:experiences" /> },
      { icon: '/images/about-page/bookings.png', text: <Translate id="about:bookings" /> },
      { icon: '/images/about-page/clubs.png', text: <Translate id="about:clubs" /> },
      { icon: '/images/about-page/hobbies.png', text: <Translate id="about:hobbies" /> },
      { icon: '/images/about-page/sports.png', text: <Translate id="about:sports" /> },
      { icon: '/images/about-page/culture.png', text: <Translate id="about:culture" /> },
      {
         icon: '/images/about-page/esports.svg',
         text: <Translate id="about:esports and gaming" />,
      },
      {
         icon: '/images/about-page/wallet.png',
         text: <Translate id="about:fintech wallet" />,
      },
      {
         icon: '/images/about-page/augmented.png',
         text: <Translate id="about:augmented reality" />,
      },
      {
         icon: '/images/about-page/event-tickets.png',
         text: <Translate id="about:event tickets" />,
      },
   ];
   return (
      <Container className="mt-32 text-center">
         <div className="mb-4 text-4xl font-light">
            <Translate id="about:be the voice" />
         </div>
         <div className="text-6xl italic font-bold uppercase">
            <Translate id="about:bold saudi" />
         </div>
         <div>
            <p className="max-w-6xl mx-auto mb-12 text-2xl font-light md:mb-16 mt-7">
               <Translate id="about:journey began" />
            </p>
         </div>
         <div className="flex flex-col justify-between max-w-6xl mx-auto space-y-4 text-lg italic font-light md:flex-row md:space-y-0 md:space-x-4 md:rtl:space-x-reverse">
            <p className="max-w-lg mx-auto">
               <Translate id="about:addicted to innovation" />
            </p>
            <p className="max-w-lg mx-auto">
               <Translate id="about:cutting edge tech" />
            </p>
         </div>
         <div className="my-20">
            <ul>
               {boldSaudiIcons.map((a, idx) => (
                  <li className="inline-block w-40 my-12 md:w-48" key={idx}>
                     <img className="mx-auto" src={a.icon} width="68" height="59" />
                     <div className="font-light leading-6">{a.text}</div>
                  </li>
               ))}
            </ul>
         </div>
      </Container>
   );
};

export default BoldSaudi;
